import React from 'react';

import { connect } from 'react-redux';
import { Field, Formik } from 'formik';

import Typography from '@material-ui/core/Typography';

import SelectField from '../../components/SelectField';
import ScreenWrapper from '../../components/ScreenWrapper';

import typeOfHomeOptions from '../../constants/typeOfHomeOptions';
import { PAGES } from '../../config/constants';

const TypeOfHome = ({ type_of_loan, setPage, setFormValue }) => {
  return (
    <React.Fragment>
      <h1
        style={{
          textAlign: 'center',
          fontSize: '60px',
          fontStyle: 'normal',
          fontWeight: 600,
          marginTop: -10,
          '@media (max-width: 375px)': {
            fontSize: '28px',
          }
        }}
      >
        Welcome to Premier Money Source.
      </h1>
      <Typography
        style={{
          marginTop: 30,
          fontSize: 22,
          textAlign: 'center',
          marginBottom: 10,
          '@media (max-width: 375px)': {
            fontSize: '17px',
          }
        }}
      >
        Which loan program would you like to apply for ?
      </Typography>
      <ScreenWrapper step={1}>
        <Formik
          initialValues={{ type_of_loan: type_of_loan }}
          onSubmit={values => {
            setFormValue(values);
            setPage();
          }}
          validate={validate}
        >
          {({ handleSubmit }) => (
            <React.Fragment>
              <Field
                name="type_of_loan"
                component={SelectField}
                label="Type Of Loan"
                options={typeOfHomeOptions}
                required
                cstmOnChange={async () => {
                  await Promise.resolve();
                  handleSubmit();
                }}
              />

              <div style={{ float: 'right', marginTop: 10 }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-blue"
                  onClick={handleSubmit}
                >
                  Next
                </button>
              </div>
            </React.Fragment>
          )}
        </Formik>
      </ScreenWrapper>
    </React.Fragment>
  );
};

const validate = values => {
  let errors = {};

  if (!values.type_of_loan) {
    errors.type_of_loan = 'Required';
  }

  return errors;
};

const mapState = state => {
  return {
    type_of_loan: state.form.accounts.type_of_loan,
  };
};

const mapDispatch = dispatch => {
  return {
    setPage: () => {
      dispatch({
        type: 'SET_PAGE',
        payload: PAGES.SUBMITTING_LOAN,
      });
    },
    setFormValue: values => {
      dispatch({
        type: 'SET_FORM_ACCOUNTS',
        payload: values,
      });
    },
  };
};

export default connect(mapState, mapDispatch)(TypeOfHome);



// WEBPACK FOOTER //
// ./src/Screens/TypeOfHome/index.js